import { useQuery, useQueryClient } from "@tanstack/react-query";

import { listActivity } from "../../api/activity";
import { myClaims } from "../../api/claims";
import { ME_KEY } from "../auth/session";
import { COMPANIES_KEY } from "../companies/queries";

export const MY_CLAIMS_KEY = ["me", "claims"] as const;
export const ACTIVITY_KEY = ["activity"] as const;

export function useMyClaims() {
  return useQuery({ queryKey: MY_CLAIMS_KEY, queryFn: myClaims });
}

/** The badge: unread notifications over all tabs. Refreshed every minute. */
export function useUnreadCount() {
  return useQuery({
    queryKey: [...ACTIVITY_KEY, "unread"],
    queryFn: async () => (await listActivity("all", null, 1)).unread_count,
    refetchInterval: 60_000,
  });
}

/** After a claim, waitlist or reminder change: everything that shows it reloads. */
export function useRefreshAfterChange() {
  const client = useQueryClient();
  return () => {
    for (const key of [COMPANIES_KEY, ME_KEY, MY_CLAIMS_KEY, ACTIVITY_KEY]) {
      void client.invalidateQueries({ queryKey: key });
    }
  };
}
